<template>
    <div class="todo-item" v-bind:class="{'is-completed':todo.completed}">
        <p>
            <input type="checkbox" v-on:change="markComplete">
            {{todo.title}}
            <button class="del" @click="$emit('del-todo', todo.id)">X</button>
        </p>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: "TodoItem",
    props: ["todo"],
    methods: {
        markComplete() {
            axios.put('https://steven-schwehm.de/vuetry.php', {data: this.todo.id, data2: !this.todo.completed})
            .then(this.todo.completed = !this.todo.completed)
            .catch(err => console.log(err));
        }
    }
}
</script>

<style scoped>
    .todo-item {
        background-color: #f4f4f4;
        padding: 10px;
        border-bottom: 1px #CCC dotted;
    }

    .is-completed {
        text-decoration: line-through;
    }

    .del {
        background:#ff0000;
        color: #fff;
        border: none;
        padding: 5px 9px;
        border-radius: 50%;
        cursor: pointer;
        float: right;
    }
</style>